const DOCUMENT = 'FUTURE_JOBS_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_MULTI_DAY_SUCCESS: DOCUMENT + 'LOAD_MULTI_DAY_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  RUN_MA: DOCUMENT + 'RUN_MA',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadMultiDayDataSuccess: data => ({
    type: actions.LOAD_MULTI_DAY_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  runMa: data => ({
    type: actions.RUN_MA,
    payload: data,
  }),
};

export default actions;
